import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import API from '../endpoints';

type Payload = {
  name: string;
  subject: string;
  message: string;
  email: string;
  recaptchaToken: string;
};

export const useContactUsMutation = (mutationArgs?: Omit<typeof useMutation, 'mutationFn'>) => {
  return useMutation({
    ...(mutationArgs ?? {}),
    onSuccess: (...args) => {
      // @ts-expect-error - useMutation type incompatibility with onSuccess callback parameters
      mutationArgs?.onSuccess?.(...args);
    },
    mutationFn: sendContactUs,
  });
};

const sendContactUs = async (payload: Payload) => {
  const { data } = await axios.post<{ isSuccess: boolean; error?: Record<keyof Payload, string> }>(
    `${API.endpoints.contactUs}`,
    payload,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  return data;
};
